"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var prop = require('./prop');

function id(e) {
  return e;
}

module.exports = function tester(test) {
  return 'object' === _typeof(test) && 'function' === typeof test.test //regexp
  ? function (data) {
    return test.test(data);
  } : prop(test) || id;
};